/**
 * Тур `tempmail-main` v1.0.0 (ТЗ §4).
 *
 * Литерал, а не результат `parseManifest`: Zod весит больше самого движка, поэтому
 * схема применяется в юнит-тесте и CI-гейте G-4, а в рантайм-чанк не попадает.
 *
 * Правила изменения манифеста:
 *   - новый шаг → рост MINOR, `introducedIn` = новая версия;
 *   - переписан текст шага по смыслу → `rev` + 1 и `resurfaceOnChange: true`, рост MINOR;
 *   - косметическая правка → рост PATCH, `rev` не трогаем;
 *   - удаление шага → id переносится в `retiredSteps` и больше никогда не используется.
 */

import type { OnboardingManifest } from './schema';

export const TEMPMAIL_MAIN_TOUR_ID = 'tempmail-main';

export const tempmailMainManifest: OnboardingManifest = {
  tourId: TEMPMAIL_MAIN_TOUR_ID,
  version: '1.0.0',
  campaignId: '2026-q3-base',
  retiredSteps: [],
  steps: [
    {
      // Вариант для пользователя без ящиков: шаг ведёт к созданию первого адреса.
      id: 'mailbox.create.first',
      variantGroup: 'mailbox.create',
      rev: 1,
      resurfaceOnChange: false,
      introducedIn: '1.0.0',
      order: 10,
      route: '/',
      anchor: 'mailbox.addButton',
      placement: 'bottom',
      fallback: 'center',
      spotlight: true,
      i18nKey: 'onboarding.tempmailMain.mailboxCreateFirst',
      when: { mailboxCount: { eq: 0 } },
      action: { type: 'awaitEvent', event: 'mailbox.created', timeoutMs: 60_000 },
    },
    {
      // Тот же смысл для пользователя, у которого ящик уже есть: без подсветки и ожидания.
      id: 'mailbox.create',
      variantGroup: 'mailbox.create',
      rev: 1,
      resurfaceOnChange: false,
      introducedIn: '1.0.0',
      order: 10,
      route: '/',
      anchor: 'mailbox.addButton',
      placement: 'bottom',
      fallback: 'center',
      spotlight: false,
      i18nKey: 'onboarding.tempmailMain.mailboxCreate',
      when: { mailboxCount: { gte: 1 } },
      action: { type: 'none' },
    },
    {
      id: 'quota.traffic',
      variantGroup: null,
      rev: 1,
      resurfaceOnChange: false,
      introducedIn: '1.0.0',
      order: 20,
      route: '/',
      anchor: 'mailbox.quotaBlock',
      placement: 'bottom',
      fallback: 'center',
      spotlight: false,
      i18nKey: 'onboarding.tempmailMain.quotaTraffic',
      when: null,
      action: { type: 'none' },
    },
    {
      // Баннер переадресации скрывается, когда она уже настроена, — тогда и шаг не нужен.
      id: 'forwarding.intro',
      variantGroup: null,
      rev: 1,
      resurfaceOnChange: false,
      introducedIn: '1.0.0',
      order: 30,
      route: '/',
      anchor: 'mailbox.forwardingBanner',
      placement: 'bottom',
      fallback: 'skip',
      spotlight: false,
      i18nKey: 'onboarding.tempmailMain.forwardingIntro',
      when: { forwardingReady: { eq: false } },
      action: { type: 'none' },
    },
    {
      id: 'mailbox.manage',
      variantGroup: null,
      rev: 1,
      resurfaceOnChange: false,
      introducedIn: '1.0.0',
      order: 40,
      route: '/',
      anchor: 'mailbox.card.menu',
      placement: 'left',
      fallback: 'skip',
      spotlight: false,
      i18nKey: 'onboarding.tempmailMain.mailboxManage',
      when: { mailboxCount: { gte: 1 } },
      action: { type: 'none' },
    },
  ],
};
